var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Message } from 'packages/email/entities/Message';
import Icon from 'common/UIToolKit/Icon.vue';
import Avatar from 'common/UIToolKit/Avatar.vue';
import DateField from 'ui/v1/DateField.vue';
import stripPersonalDataFromUrlsInClipboard from 'common/support/stripPersonalDataFromUrlsInClipboard';
var EmailMessage = /** @class */ (function (_super) {
    __extends(EmailMessage, _super);
    function EmailMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userRemoved = false;
        return _this;
    }
    EmailMessage.prototype.mounted = function () {
        window.addEventListener('copy', stripPersonalDataFromUrlsInClipboard);
        if (!this.message.sender.name) {
            this.userRemoved = true;
        }
    };
    Object.defineProperty(EmailMessage.prototype, "senderName", {
        get: function () {
            var _a, _b;
            if (this.userRemoved) {
                return this.$t('common.removed_user');
            }
            return (_b = (_a = this.message.from) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : this.message.sender.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailMessage.prototype, "senderEmail", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.message.from) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : this.message.sender.email;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop({ default: new Message() }),
        __metadata("design:type", typeof (_a = typeof Message !== "undefined" && Message) === "function" ? _a : Object)
    ], EmailMessage.prototype, "message", void 0);
    EmailMessage = __decorate([
        Component({
            name: 'EmailMessage',
            components: {
                Avatar: Avatar,
                DateField: DateField,
                Icon: Icon,
            },
        })
    ], EmailMessage);
    return EmailMessage;
}(Vue));
export default EmailMessage;
